module.exports = {"File-Date":"2017-03-03"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/language-subtag-registry/data/json/meta.json
// module id = 412
// module chunks = 3